module.exports = __webpack_public_path__ + "img/about.42b2ca18.jpeg";